const copy = {
  backToHome: "Back to home page",
  translationCallout: {
    description:
      "The Subject and Description fields of this ticket were translated because our support agents currently can only provide support in English.",
  },
  unauthorizedPrompt: {
    ungated: {
      heading: "You haven't logged in yet.",
      description:
        "Please login to verify your support plan. If you are not on one of our upgraded support plans, please use the Help Center Assistant for guided assistance, if unable to help you will be guided to open a ticket for more help.",
      actions: {
        primary: "Login",
        goToHCA: "Go to Help Center Assistant",
      },
    },
    gated: {
      heading: "You do not have access to submit a ticket.",
      description:
        "Your current support plan requires you to use the Help Center Assistant before connecting with a live support agent. Kindly start with our AI chatbot to find the information you need, if unable to find answers, the AI chatbot will assist you to submit a ticket to reach our support agents for more help. More contact channels (including access to this url) are available in our paid support plans.",
      actions: {
        primary: "Explore plans",
        goToHCA: "Go to Help Center Assistant",
      },
    },
  },
  successDetails: {
    callout: {
      description: "Please check your email inbox for further instructions",
    },
    labels: {
      attachments: "Attachments",
      comment: "Description",
      email: "Email address",
      id: "Ticket ID#",
      priorityLevel: "Business impact",
      subject: "Subject",
    },
    title: "Your ticket has been submitted!",
  },
  errors: {
    page: {
      heading: "Looks like something isn't working",
      description: "Something went wrong. Try again later.",
      log: "Unable to load Ticket Submission due to priority level and/or CSRF error",
    },
    submission: "Something went wrong with ticket submission. Try again later.",
  },
};

export default copy;
